import React from 'react';
import { Box } from '../element';
import { NavLink } from '../link';
import { VerticalWizard, WizardStepFloatedItem } from '../wizard';
import { useTranslation } from 'react-i18next';

const StepSideBarItem = (props) => {
  const { t } = useTranslation();
  const { steps, border, item, show, queryString } = props;
  const activeClass = show ? 'active' : '';
  return (
    <Box justify="start" border={border} fill={true} className="autoMinHeight">
      <NavLink
        className={'leftNavMenu ' + activeClass}
        to={item.path + queryString}
        data-test-id={`sidebar-${item.menuText}-link`}
      >
        {t(item.menuText)}
      </NavLink>
      {show && (
        <Box className="paddingTop3">
          <VerticalWizard
            steps={steps}
            category={item.menuText}
            queryString={queryString}
            element={<WizardStepFloatedItem />}
          />
        </Box>
      )}
    </Box>
  );
};

export default StepSideBarItem;
